var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniTransport04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.759033,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#2E4491"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3224_13940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.759033,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#A0B5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3224_13940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.427 242.896V223.099H190.193C194.691 223.099 197.275 225.875 197.275 229.771C197.275 233.722 194.65 236.443 190.083 236.443H186.529V242.896H182.427ZM186.529 233.135H189.427C191.861 233.135 193.05 231.767 193.036 229.771C193.05 227.802 191.861 226.476 189.427 226.463H186.529V233.135ZM201.24 243.142C199.954 243.142 198.915 242.117 198.943 240.845C198.915 239.588 199.954 238.562 201.24 238.576C202.456 238.562 203.509 239.588 203.509 240.845C203.509 242.117 202.456 243.142 201.24 243.142ZM206.845 242.896V223.099H214.611C219.109 223.099 221.693 225.875 221.693 229.771C221.693 233.722 219.068 236.443 214.501 236.443H210.947V242.896H206.845ZM210.947 233.135H213.845C216.279 233.135 217.468 231.767 217.454 229.771C217.468 227.802 216.279 226.476 213.845 226.463H210.947V233.135ZM228.255 223.099V242.896H224.208V223.099H228.255ZM238.126 243.197C233.573 243.183 230.784 240.244 230.798 235.541C230.784 230.961 233.615 227.857 237.962 227.857C241.859 227.857 244.935 230.318 244.935 235.377V236.525H234.79C234.79 238.767 236.116 240.148 238.208 240.162C239.589 240.148 240.573 239.547 240.97 238.658H244.825C244.251 241.406 241.79 243.183 238.126 243.197ZM234.79 233.982H241.107C241.093 232.177 239.849 230.879 238.044 230.892C236.185 230.879 234.872 232.273 234.79 233.982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.272 179.83C137.272 176.516 139.959 173.83 143.272 173.83H169.408C172.722 173.83 175.408 176.516 175.408 179.83V212.012C175.408 215.326 172.721 218.012 169.408 218.012H143.272C139.959 218.012 137.272 215.326 137.272 212.012V179.83Z",
    fill: "#2C190E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.764 179.83C227.764 176.516 230.45 173.83 233.764 173.83H259.899C263.213 173.83 265.899 176.516 265.899 179.83V212.012C265.899 215.326 263.213 218.012 259.899 218.012H233.764C230.45 218.012 227.764 215.326 227.764 212.012V179.83Z",
    fill: "#2C190E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.557 43.7803C124.557 39.362 128.139 35.7803 132.557 35.7803H270.612C275.031 35.7803 278.612 39.362 278.612 43.7803V196.554C278.612 200.972 275.031 204.554 270.612 204.554H132.557C128.139 204.554 124.557 200.972 124.557 196.554V43.7803Z",
    fill: "#FF975C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.557 159.741H278.612V166.052H124.557V159.741Z",
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.612 35.7803H132.557C128.139 35.7803 124.557 39.362 124.557 43.7803V60.9971L235.664 204.554H270.612C275.031 204.554 278.612 200.972 278.612 196.554V43.7803C278.612 39.362 275.031 35.7803 270.612 35.7803Z",
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.272 53.9827C137.272 51.7735 139.063 49.9827 141.272 49.9827H261.898C264.107 49.9827 265.898 51.7735 265.898 53.9827V111.785C265.898 113.994 264.107 115.785 261.898 115.785H141.272C139.063 115.785 137.272 113.994 137.272 111.785V53.9827Z",
    fill: "#FAB087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.272 77.3203V111.786C137.272 113.995 139.063 115.786 141.272 115.786H167.132L137.272 77.3203Z",
    fill: "#FFCBAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.338 49.9827H169.5L201.633 115.785H185.471L153.338 49.9827Z",
    fill: "#FFE7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.407 49.9827H180.323L212.455 115.785H207.54L175.407 49.9827Z",
    fill: "#FFE7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.407 175.831C175.407 174.726 176.303 173.831 177.407 173.831H225.762C226.867 173.831 227.762 174.726 227.762 175.831V189.284C227.762 190.388 226.867 191.284 225.762 191.284H177.407C176.303 191.284 175.407 190.388 175.407 189.284V175.831Z",
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.763 189.284V175.831C227.763 174.726 226.867 173.831 225.763 173.831H211.983L225.147 191.284H225.763C226.867 191.284 227.763 190.388 227.763 189.284Z",
    fill: "#58270B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42 177.561C178.42 177.008 178.868 176.561 179.42 176.561H223.75C224.302 176.561 224.75 177.008 224.75 177.561V187.554C224.75 188.106 224.302 188.554 223.75 188.554H179.42C178.868 188.554 178.42 188.106 178.42 187.554V177.561Z",
    fill: "#FFE8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.749 187.554V177.561C224.749 177.008 224.301 176.561 223.749 176.561H214.167L222.767 188.15C222.956 188.404 223.254 188.554 223.57 188.554H223.749C224.301 188.554 224.749 188.106 224.749 187.554Z",
    fill: "#EAAA86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.272 177.561C137.272 177.008 137.72 176.561 138.272 176.561H159.38C159.932 176.561 160.38 177.008 160.38 177.561V187.554C160.38 188.106 159.932 188.554 159.38 188.554H138.272C137.72 188.554 137.272 188.106 137.272 187.554V177.561Z",
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79 177.561C242.79 177.008 243.238 176.561 243.79 176.561H264.898C265.45 176.561 265.898 177.008 265.898 177.561V187.554C265.898 188.106 265.45 188.554 264.898 188.554H243.79C243.238 188.554 242.79 188.106 242.79 187.554V177.561Z",
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.979,
    y: 83.1316,
    width: 7.57811,
    height: 2.61076,
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.656 83.8838C108.656 83.3315 109.103 82.8838 109.656 82.8838H119.263C119.815 82.8838 120.263 83.3315 120.263 83.8838V99.2209C120.263 99.7732 119.815 100.221 119.263 100.221H109.656C109.103 100.221 108.656 99.7732 108.656 99.2209V83.8838Z",
    fill: "#B0511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.55 85.001C109.55 84.4487 109.998 84.001 110.55 84.001H118.369C118.921 84.001 119.369 84.4487 119.369 85.001V98.1039C119.369 98.6561 118.921 99.1039 118.369 99.1039H110.55C109.998 99.1039 109.55 98.6561 109.55 98.1039V85.001Z",
    fill: "#FFCBAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.206 84.001H110.55C109.998 84.001 109.55 84.4487 109.55 85.001V86.5681C109.55 86.7513 109.6 86.931 109.696 87.0876L116.709 98.6234C116.891 98.9217 117.215 99.1039 117.564 99.1039H118.369C118.921 99.1039 119.369 98.6561 119.369 98.1039V97.0372C119.369 96.8572 119.32 96.6805 119.228 96.5258L112.066 84.4896C111.885 84.1866 111.559 84.001 111.206 84.001Z",
    fill: "#FFE8DB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3224_13940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.407,
    y: 125.641,
    width: 52.3564,
    height: 3.12852,
    rx: 1.56426,
    fill: "#58270B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.407 126.705V127.771C175.407 128.324 175.855 128.771 176.407 128.771H177.001L175.407 126.705Z",
    fill: "#D25E1D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3224_13940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.407,
    y: 131.763,
    width: 52.3564,
    height: 3.12852,
    rx: 1.56426,
    fill: "#D25E1D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3224_13940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.2 131.763H179.332L181.776 134.892H226.2C227.064 134.892 227.764 134.192 227.764 133.328C227.764 132.464 227.064 131.763 226.2 131.763Z",
    fill: "#58270B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3224_13940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.407,
    y: 137.885,
    width: 52.3564,
    height: 3.12852,
    rx: 1.56426,
    fill: "#D25E1D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3224_13940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.199 137.885H184.073L186.536 141.014H226.199C227.063 141.014 227.764 140.314 227.764 139.45C227.764 138.586 227.063 137.885 226.199 137.885Z",
    fill: "#58270B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.612 166.052V159.741H200.906L205.923 166.052H278.612Z",
    fill: "#58270B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3224_13940",
    x: 175.407,
    y: 125.641,
    width: 52.3564,
    height: 3.32842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.208333 0 0 0 0 0.0813368 0 0 0 0 0.0269097 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3224_13940"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3224_13940",
    x: 175.407,
    y: 131.763,
    width: 52.3564,
    height: 3.32842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3224_13940"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3224_13940",
    x: 179.332,
    y: 131.763,
    width: 48.4326,
    height: 3.32842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.208333 0 0 0 0 0.0813368 0 0 0 0 0.0269097 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3224_13940"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3224_13940",
    x: 175.407,
    y: 137.885,
    width: 52.3564,
    height: 3.32842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3224_13940"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3224_13940",
    x: 184.073,
    y: 137.885,
    width: 43.6907,
    height: 3.32842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.208333 0 0 0 0 0.0813368 0 0 0 0 0.0269097 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3224_13940"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTransport04);
export default __webpack_public_path__ + "static/media/mini_transport_04.0d1490b7d13c49f03511896fd24343b8.svg";
export { ForwardRef as ReactComponent };